import type { ModuleNav } from '@saas/ui';

export const STORAGE_READ = 'storage.file.read';
export const STORAGE_WRITE = 'storage.file.write';
export const STORAGE_SHARE = 'storage.share.create';
export const STORAGE_ADMIN = 'storage.admin';

/** apps/web のシェルが集約する。登録はリードが行う（apps/web/src/app/shell/nav.ts） */
export const storageNav: ModuleNav = {
  module: 'storage',
  items: [{ label: 'ファイル', to: '/storage', icon: 'folder', permission: [STORAGE_READ], description: '会社のフォルダと共有リンク' }],
  admin: [{ label: 'ファイル共有', to: '/storage/admin', icon: 'folder', permission: [STORAGE_ADMIN], description: '容量・共有リンク・同期の端末' }],
};
